import { useState, useRef, useEffect } from "react";
import "./Temporizador.css";

const Temporizador = ({onChange, colorDisable }) => {
  const intervalRef = useRef(null);
  const [timer, setTimer] = useState("00");
  const getTimeRemaining = (endtime) => {
    const total = Date.parse(endtime) - Date.parse(new Date());
    const seconds = Math.floor((total / 1000) % 60);
    const minutes = Math.floor((total / 1000 / 60) % 60);
    return { total, seconds, minutes };
  };

  const starTimer = (deadline) => {
    const { total, seconds, minutes } = getTimeRemaining(deadline);
    if (total >= 0) {
      setTimer(
        (minutes > 9 ? minutes : "0" + minutes) +
          ":" +
          (seconds > 9 ? seconds : "0" + seconds)
      );
    } else {
      clearInterval(intervalRef.current);
    }
  };

  const clearTime = (endtime) => {
    setTimer("01:00");
    if (intervalRef.current) clearInterval(intervalRef.current);
    const id = setInterval(() => {
      starTimer(endtime);
    }, 1000);
    intervalRef.current = id;
  };

  const getDeadlineTime = () => {
    const deadline = new Date();
    deadline.setMinutes(deadline.getMinutes() + 0);
    deadline.setSeconds(deadline.getSeconds() + 60);
    return deadline;
  };

  useEffect(() => {
    clearTime(getDeadlineTime());
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (timer === "00:00") {
      clearTime(getDeadlineTime());
      onChange();
    }
    //eslint-disable-next-line
  }, [timer]);

  return (
    <div className="agenda-container-temporizador">
        <span className="agenda-temporizador-reloj rbm14l c-grey45">{timer}</span>
    </div>
  );
};

export default Temporizador;
